module.exports = __webpack_public_path__ + "media/promotions/back-to-school-deals-background-tile_@2x-1a8812ba.png";